import React from 'react';
import { Users, Award, Target } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-[#0B0B0B] to-[#1a1a1a]">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 font-playfair leading-tight">
                Redefining Men's Grooming in Malaysia
              </h2>
              <div className="w-24 h-1 bg-[#C9A227] mb-6"></div>
              <p className="text-lg text-gray-300 leading-relaxed mb-6">
                Since 2017, Mark's Barber has been Malaysia's premier destination for discerning gentlemen who demand excellence in grooming. We blend classic barbering traditions with contemporary styling techniques to deliver an unmatched experience.
              </p>
              <p className="text-lg text-gray-300 leading-relaxed">
                Our master barbers are trained in precision cutting, beard sculpting, and traditional shaving techniques. Every service is performed with meticulous attention to detail, using only premium international grooming products.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-[#C9A227] mb-2 font-playfair">8+</div>
                <div className="text-sm text-gray-400 uppercase tracking-wide">Years Excellence</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#C9A227] mb-2 font-playfair">5</div>
                <div className="text-sm text-gray-400 uppercase tracking-wide">Premium Locations</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#C9A227] mb-2 font-playfair">50K+</div>
                <div className="text-sm text-gray-400 uppercase tracking-wide">Happy Customers</div>
              </div>
            </div>
          </div>

          {/* Right Content - Features */}
          <div className="space-y-6">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 hover:bg-white/10 transition-colors duration-300">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#C9A227] rounded-lg flex items-center justify-center flex-shrink-0">
                  <Award className="w-6 h-6 text-black" strokeWidth={2} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-2 font-playfair">Professional Craftsmanship</h3>
                  <p className="text-gray-400 leading-relaxed">
                    Our barbers undergo continuous training in the latest techniques and classic methods, ensuring every cut meets the highest standards of precision and style.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 hover:bg-white/10 transition-colors duration-300">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#C9A227] rounded-lg flex items-center justify-center flex-shrink-0">
                  <Target className="w-6 h-6 text-black" strokeWidth={2} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-2 font-playfair">Personalized Experience</h3>
                  <p className="text-gray-400 leading-relaxed">
                    We believe grooming is personal. Each service begins with a consultation to understand your style, preferences, and lifestyle for a truly tailored result.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 hover:bg-white/10 transition-colors duration-300">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-[#C9A227] rounded-lg flex items-center justify-center flex-shrink-0">
                  <Users className="w-6 h-6 text-black" strokeWidth={2} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-2 font-playfair">Luxury Environment</h3>
                  <p className="text-gray-400 leading-relaxed">
                    Step into a sophisticated space designed for the modern gentleman. Enjoy complimentary beverages, comfortable seating, and an ambiance that elevates your grooming ritual.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;